import React from 'react';
import './LandingPageV2.css';

function TermsPage() {
  return (
    <div className="landing-v2">
      <header className="landing-v2-header">
        <div className="header-container">
          <div className="logo">
            <img
              src={process.env.PUBLIC_URL + '/logo512.png'}
              alt="Supchats logo"
              className="logo-img"
            />
            <span className="logo-text">Supchats</span>
          </div>
        </div>
      </header>

      <div className="public-page">
        <div className="public-hero">
          <h1>Terms and Conditions</h1>
          <p>
            These Terms govern your access to and use of the Supchats service,
            including the chat widget, AI features and admin dashboard.
          </p>
        </div>

        <div className="public-section">
          <h2>1. Agreement with Supchats</h2>
          <p>
            By creating an account, installing the widget or otherwise using
            Supchats, you agree to be bound by these Terms and our Privacy
            Policy. If you use Supchats on behalf of a company, you represent
            that you have authority to bind that company to this agreement.
          </p>
        </div>

        <div className="public-section">
          <h2>2. Your account and security</h2>
          <ul>
            <li>You are responsible for keeping your login credentials safe.</li>
            <li>
              All actions taken through your account are deemed to be performed
              by you or your authorized users.
            </li>
            <li>
              You must notify us immediately if you suspect any unauthorized use
              of your account or any other security breach.
            </li>
          </ul>
        </div>

        <div className="public-section">
          <h2>3. Acceptable use</h2>
          <p>You agree not to use Supchats to:</p>
          <ul>
            <li>
              send or store content that is illegal, defamatory, hateful,
              discriminatory or otherwise violates applicable laws;
            </li>
            <li>harass or abuse individuals or organizations;</li>
            <li>
              attempt to gain unauthorized access to the service or related
              systems;
            </li>
            <li>
              interfere with or disrupt the integrity or performance of the
              service;
            </li>
            <li>
              reverse engineer, copy or resell the service except as explicitly
              permitted.
            </li>
          </ul>
        </div>

        <div className="public-section">
          <h2>4. Customer content and responsibility</h2>
          <p>
            You are solely responsible for the content of messages and data
            processed through your Supchats account and widget. You guarantee
            that your use of the service and your message content comply with
            applicable laws, including data‑protection and consumer‑protection
            rules. Supchats does not control or endorse any content you or your
            users submit and assumes no liability arising from such content.
          </p>
        </div>

        <div className="public-section">
          <h2>5. Data protection</h2>
          <p>
            When using Supchats, you act as the data controller for your
            visitors&apos; personal data, and Supchats acts as your data
            processor. You must provide appropriate privacy notices and obtain
            any consents required under applicable law. We process personal data
            on your behalf as described in our Privacy Policy and, where
            applicable, in a separate Data Processing Agreement.
          </p>
        </div>

        <div className="public-section">
          <h2>6. Plans, fees and changes to the service</h2>
          <p>
            Supchats may offer both free and paid plans. Any fees, limits and
            billing terms applicable to your account are described in the
            dashboard or order form. We may modify features, limits or prices
            from time to time; where required, we will notify you in advance and
            give you an opportunity to cancel before changes take effect.
          </p>
        </div>

        <div className="public-section">
          <h2>7. Availability and support</h2>
          <p>
            We aim to keep Supchats available and performant, but we do not
            guarantee that the service will be uninterrupted or error‑free.
            Short interruptions for maintenance, updates or incidents may occur.
            Support is provided on a commercially reasonable basis.
          </p>
        </div>

        <div className="public-section">
          <h2>8. Intellectual property</h2>
          <p>
            Supchats, including all related software, design, trademarks and
            documentation, is owned by TecophoneLTD or its licensors. You are
            granted a limited, non‑exclusive, non‑transferable license to use
            the service for your internal business purposes in accordance with
            these Terms. You may not remove or obscure Supchats branding from
            the widget except where your plan explicitly allows white‑label
            use.
          </p>
        </div>

        <div className="public-section">
          <h2>9. Third‑party services</h2>
          <p>
            The service may integrate with third‑party tools (for example CMS
            platforms, CRMs or analytics). Your use of such tools is governed by
            the terms of those providers, and Supchats is not responsible for
            their actions, content or processing of data.
          </p>
        </div>

        <div className="public-section">
          <h2>10. Disclaimer and limitation of liability</h2>
          <p>
            Supchats is provided on an &quot;as is&quot; and &quot;as
            available&quot; basis. To the maximum extent permitted by law, we
            disclaim all warranties, whether express or implied, including
            implied warranties of merchantability, fitness for a particular
            purpose and non‑infringement. Supchats will not be liable for any
            indirect, incidental, special or consequential damages, loss of
            profits, loss of data or business interruption, even if advised of
            the possibility of such damages.
          </p>
        </div>

        <div className="public-section">
          <h2>11. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Supchats, its owners,
            employees and partners from any claims, damages, losses or expenses
            arising from your use of the service, your violation of these Terms
            or your violation of any third‑party rights.
          </p>
        </div>

        <div className="public-section">
          <h2>12. Term and termination</h2>
          <p>
            You may stop using Supchats at any time. We may suspend or terminate
            your access to the service if you materially breach these Terms or
            use the service in a way that creates risk or harm for us, other
            users or third parties. Upon termination, your right to access the
            service ceases, but provisions that by their nature should survive
            (such as limitations of liability and intellectual‑property
            provisions) will remain in effect.
          </p>
        </div>

        <div className="public-section">
          <h2>13. Changes to these Terms</h2>
          <p>
            We may update these Terms from time to time. When we make material
            changes, we will notify you by email or via the dashboard. Your
            continued use of Supchats after the updated Terms become effective
            constitutes your acceptance of the changes.
          </p>
        </div>

        <div className="public-section">
          <h2>14. Governing law</h2>
          <p>
            Unless otherwise required by mandatory law, these Terms are governed
            by the laws of Cyprus, without regard to its conflict‑of‑laws
            rules. Any disputes will be resolved by the competent courts of
            Cyprus, unless the parties agree on another method of dispute
            resolution.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;

